import TaxTreatmentFields from './TaxTreatmentFields';
//frontend/src/components/SubscriptionForm
import React, { useState, useEffect, useCallback } from "react";
/* global axios */
import api from '../services/apiService';
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { isHoliday } from './holidays'; // Pfad anpassen, z. B. './holidays' oder '../holidays'
import { Helmet } from 'react-helmet';  // Import von React Helmet

// Funktion zur Formatierung des Datums in "TT.MM.JJJJ"
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

const SubscriptionForm = ({ mode, onSave }) => {
  const { subscriptionId } = useParams();
  const navigate = useNavigate();

  const [subscription, setSubscription] = useState({
    customerId: "",
    contactId: "",
    lwOperatorId: "",  // Ansprechpartner vor Ort hinzufügen
    deliveryTime: "",
    operationLocation: "",
    notes: "",
    transportNotes: "",
    date: "",
    validUntil: "",
    status: "pending", // Standardstatus für Aufträge
    referenceNumber: "", 
    smartRental: false,            // Neu: SmartRental Checkbox
    obligationInstruction: false,
    subscriptionType: "standard",
  });

  // Temporäre Zustände für die Checkboxen
  const [tempIncludeSaturday, setTempIncludeSaturday] = useState(false);
  const [tempIncludeSunday, setTempIncludeSunday] = useState(false);
  const [tempIncludeHolidays, setTempIncludeHolidays] = useState(false);

  // Zustände für Auftragspositionen und verfügbare Artikel
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [subscriptionItems, setSubscriptionItems] = useState([]);  // State für Auftragspositionen
  const [items, setItems] = useState([]);  // State für alle verfügbaren Artikel
  const [editingRowId, setEditingRowId] = useState(null); // Verfolgt die aktuell bearbeitete Zeile
  const [units, setUnits] = useState([]); // State für Einheiten
  const [selectedUnitId, setSelectedUnitId] = useState(null); // Zustand für die zuletzt verwendete Einheit
  const isEditing = editingRowId !== null;
  const [tempRentalPeriodFrom, setTempRentalPeriodFrom] = useState("");
  const [tempRentalPeriodTo, setTempRentalPeriodTo] = useState("");
  const [tempRentalTimeFrom, setTempRentalTimeFrom] = useState("");
  const [tempRentalTimeTo, setTempRentalTimeTo] = useState("");
  const [originalSubscriptionItems, setOriginalSubscriptionItems] = useState([]);
  const [calculatedSubscriptionItems, setCalculatedSubscriptionItems] = useState([]); // Berechnete Daten
  // Dialog anzeigen oder verbergen
 
  // Vom Dialog ausgewählte Rental-Artikel (Option aus SubscriptionItems)
  const [selectedRentalArticle, setSelectedRentalArticle] = useState(null);
  // Vom Dialog ausgewählter WorkshopOrderType
 

  // Hilfsfunktion zum Parsen von Zeitstrings "HH:MM" in Millisekunden seit Mitternacht
  const parseTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return (hours * 60 + minutes) * 60 * 1000; // Millisekunden
  };





  // Filtere alle SubscriptionItems, die als Rental-Artikel gelten:
const rentalOptions = subscriptionItems
.filter(item => item.item?.itemType === 'rental')
.map(item => ({
  value: item.itemId, // oder alternativ item.id, je nach gewünschtem Schlüssel
  label: item.item?.name,
}));





  const updateRentalPeriodTo = useCallback(() => {
    // Filtern Sie alle subscriptionItems vom Typ "rental"
    const rentalItems = subscriptionItems.filter(item => {
      const correspondingItem = items.find(i => i.id === item.itemId);
      return correspondingItem && correspondingItem.itemType === "rental";
    });

    let updated = false; // Flag zur Überprüfung, ob eine Aktualisierung notwendig ist

    // Erstellen Sie eine neue Version von subscriptionItems mit aktualisierten rentalPeriodTo
    const newSubscriptionItems = subscriptionItems.map(item => {
      if (rentalItems.some(rentalItem => rentalItem.id === item.id)) {
        if (item.rentalPeriodFrom && item.quantity) {
          const startDate = new Date(item.rentalPeriodFrom);
          let rentalDays = item.quantity; // Anzahl der gewünschten Tage oder Stunden
          let isTimeBased = false; // Flag zur Bestimmung, ob die Einheit zeitbasiert ist

          // Überprüfen, ob die Einheit zeitbasiert ist (angenommen, unitId === 27 bedeutet Stunden)
          if (item.unit && item.unit.id === 27) {
            isTimeBased = true;

            // Prüfen, ob beide Zeitfelder ausgefüllt sind und die Einheit auf Zeit steht
            if (item.rentalTimeFrom && item.rentalTimeTo) {
              const timeFrom = parseTime(item.rentalTimeFrom);
              const timeTo = parseTime(item.rentalTimeTo);

              // Berechnung der Stunden im Zeitfenster
              const hoursPerDay = (timeTo - timeFrom) / (1000 * 60 * 60); // Annahme: Zeit als "HH:MM" String

              if (hoursPerDay > 0) {
                rentalDays = Math.ceil(item.quantity / hoursPerDay);
              } else {
                // Falls timeTo kleiner oder gleich timeFrom ist, Standard von 24 Stunden verwenden
                rentalDays = Math.ceil(item.quantity / 24);
              }
            } else {
              // Wenn nur eines oder keine Zeitfelder ausgefüllt ist, Standard 24 Stunden verwenden
              rentalDays = Math.ceil(item.quantity / 24);
            }
          }

          let daysAdded = 1; // Starttag sofort zählen
          let currentDate = new Date(startDate);

          while (daysAdded < rentalDays) {
            currentDate.setDate(currentDate.getDate() + 1);
            const dayOfWeek = currentDate.getDay(); // 0=So, 6=Sa

            // Prüfen, ob dieser Tag ein Miettag ist:
            // - Werktag (Mo–Fr), außer Feiertag, wenn includeHolidays = false
            // - Samstag, wenn includeSaturday = true
            // - Sonntag, wenn includeSunday = true
            // - Feiertag, nur wenn includeHolidays = true
            if (
              (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(currentDate)) // normaler Werktag
              || (item.includeSaturday && dayOfWeek === 6)
              || (item.includeSunday && dayOfWeek === 0)
              || (item.includeHolidays && isHoliday(currentDate))
            ) {
              daysAdded++;
            }
          }

          // currentDate ist jetzt der letzte Miettag
          const rentalPeriodToDate = new Date(currentDate);
          const formattedRentalPeriodTo = rentalPeriodToDate.toISOString().split('T')[0];

          // Überprüfen, ob eine Aktualisierung notwendig ist
          if (item.rentalPeriodTo !== formattedRentalPeriodTo) {
            updated = true;
            return { ...item, rentalPeriodTo: formattedRentalPeriodTo };
          }
        }
      }
      return item;
    });

    // Aktualisieren Sie den State nur, wenn eine Änderung vorgenommen wurde
    if (updated) {
      setSubscriptionItems(newSubscriptionItems);
    }
  }, [subscriptionItems, items, parseTime]);

  // Funktion zur Aktualisierung der Einheit im Backend
  const updateSubscriptionItemUnit = async (subscriptionId, subscriptionItemId, newUnitId, newQuantity) => {
    try {
      const payload = {
        id: subscriptionItemId,
        unitId: newUnitId,
        quantity: newQuantity,  // Hier fügst du die Menge hinzu
      };

      const response = await api.put(
        `/subscriptions/${subscriptionId}/subscriptionitems/${subscriptionItemId}`, 
        payload
      );
      console.log('Einheit und Menge erfolgreich aktualisiert:', response.data);
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Einheit:', error);
    }
  };

  const getMatchingPricing = (item, quantity, newUnitId) => {
    // Überprüfen, ob die Preisstaffelung existiert für die neue Einheit (newUnitId)
    const pricing = item.item.machineType?.typePricings.find((pricing) => {
      return quantity >= pricing.minQuantity && quantity <= pricing.maxQuantity && pricing.unitId === newUnitId;
    });

    if (pricing) {
      const pricePerUnit = pricing.pricePerUnit;
      const total = pricePerUnit * quantity;
      return { pricePerUnit, total };
    } else {
      // Wenn keine Preisstaffelung gefunden wird, setze Standardwerte
      return { pricePerUnit: 0, total: 0 };
    }
  };

  // Auftragspositionen entfernen
  const removeSubscriptionItem = async (subscriptionItemId) => {
    console.log("Remove-Handler aufgerufen mit ID:", subscriptionItemId);
    try {
      console.log(`Entferne Auftragsposition mit ID: ${subscriptionItemId} für Auftrag ID: ${subscription.id}`);

      // API-Aufruf, um die Auftragsposition zu entfernen
      const response = await api.delete(`/subscriptions/${subscription.id}/subscriptionitems/${subscriptionItemId}`);
      console.log('API-Antwort beim Entfernen:', response.data, 'Status:', response.status);

      // Überprüfen, ob die Antwort erfolgreich war
      if (response.status === 200 || response.status === 204) {
        // Entferne das SubscriptionItem aus dem lokalen State
        setSubscriptionItems((prevItems) => {
          const updatedItems = prevItems.filter((item) => item.id !== subscriptionItemId);
          console.log("Aktualisierte Auftragspositionen nach dem Entfernen:", updatedItems); // Log hinzufügen
          return updatedItems;
        });

        console.log(`Auftragsposition mit ID ${subscriptionItemId} erfolgreich entfernt.`);
      } else {
        console.error(`Fehler beim Entfernen der Auftragsposition: Unerwarteter Status ${response.status}`);
      }
    } catch (error) {
      // Detaillierte Fehlerbehandlung und Logausgabe
      console.error('Fehler beim Entfernen der Auftragsposition:', error.message || error);

      // Benutzer über den Fehler informieren
      alert('Fehler: Die Auftragsposition konnte nicht entfernt werden. Bitte versuchen Sie es später erneut.');
    }
  };

  // Funktion zum Abrufen der Auftragspositionen
  const fetchSubscriptionItems = async () => {
    try {
      const response = await api.get(`/subscriptions/${subscriptionId}/subscriptionitems`);
      if (Array.isArray(response.data)) {
        console.log('Daten aus dem Backend:', response.data);
        
        // Füge jedem SubscriptionItem das Feld "manualPriceActive: false" hinzu:
        const itemsWithFlag = response.data.map(item => ({
          ...item,
          manualPriceActive: false
        }));
        
        setSubscriptionItems(itemsWithFlag); // Zustand aktualisieren
      }
    } catch (error) {
      console.error('Fehler beim Abrufen der Auftragspositionen:', error);
    }
  };

  // 1. Auftragspositionen abrufen, wenn subscription.id sich ändert
  useEffect(() => {
    if (subscription.id) {
      fetchSubscriptionItems(); // Funktion wird jetzt global aufgerufen
      fetchUnits(); // Einheiten abrufen (falls benötigt)
    }
  }, [subscription.id]);

  // 2. rentalPeriodTo berechnen, wenn subscriptionItems sich ändern
  useEffect(() => {
    if (subscriptionItems.length > 0) {
      updateRentalPeriodTo();
    }
  }, [subscriptionItems]);

  // 3. Artikel laden (nur beim ersten Laden der Seite)
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await api.get('/items');
        setItems(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Artikel:', error);
      }
    };
    fetchItems();
  }, []);



  useEffect(() => {
    if (subscriptionItems.length > 0) {
      // Beispiel: Setze den globalen Zustand, wenn mindestens ein SubscriptionItem includeSaturday = true hat.
      // (Anpassen – du kannst hier auch andere Logik verwenden, falls nötig.)
      setTempIncludeSaturday(subscriptionItems.some(item => item.includeSaturday));
      setTempIncludeSunday(subscriptionItems.some(item => item.includeSunday));
      setTempIncludeHolidays(subscriptionItems.some(item => item.includeHolidays));
    }
  }, [subscriptionItems]);





  // Auftragsposition hinzufügen
  const addSubscriptionItem = async () => {
    try {
      if (!selectedItemId || selectedQuantity <= 0) {
        alert('Bitte wählen Sie einen Artikel aus und geben Sie eine gültige Menge an.');
        console.warn("Ungültige Eingabedaten: ", { selectedItemId, selectedQuantity });
        return;
      }

      const item = items.find((item) => item.id === selectedItemId);
      if (!item) {
        alert('Ausgewählter Artikel existiert nicht.');
        return;
      }

      // Bestimme die finale Einheit basierend auf itemType
      let finalUnitId = null;

      switch (item.itemType) {
        case 'insurance':
          // Versicherungsartikel => standardmäßig 33 (Prozent)
          finalUnitId = 33;
          break;

        case 'rental':
          // Mietartikel => Fallback aus typePricings oder Transport
          finalUnitId =
            item.machineType?.typePricings?.[0]?.unit?.id ||
            item.transportPricings?.[0]?.unit?.id ||
            29; // oder 27 - je nachdem was du als Default willst (Stunde / Tag)
          break;

        case 'transport':
          // Transportartikel => Falls du TransportPricing hast
          finalUnitId = item.transportPricings?.[0]?.unit?.id || 34; 
          // 34 wäre z.B. "pauschal" – passe das an dein System an
          break;

        case 'sparePart':
        case 'service':
        case 'sale':
          // Ersatzteil / Service / Verkauf => aus salesPricings
          finalUnitId = item.salesPricings?.[0]?.unitId || null;
          break;
          
        default:
          // Falls es noch andere Typen gibt
          console.log(`Kein Fallback definiert für itemType='${item.itemType}'.`);
          finalUnitId = null;
          break;
      }

      // Falls finalUnitId immer noch null ist, wirf einen Fehler oder setze einen Default
      if (!finalUnitId) {
        console.warn(`Keine passende Einheit für itemType='${item.itemType}' gefunden; bitte manuell zuweisen.`);
        // finalUnitId = 29; // z.B. Tag als letzter Ausweg
      }

      const payload = {
        subscriptionId: subscription.id, // ID des aktuellen Auftrags
        itemId: selectedItemId, // ID des ausgewählten Artikels
        quantity: selectedQuantity, // Vom Benutzer eingegebene Menge
        unitId: finalUnitId,  // Einheit setzen
        rentalPeriodFrom: "", // Initial leer
        rentalPeriodTo: "",   // Initial leer
        rentalTimeFrom: "",   // Initial leer
        rentalTimeTo: "",     // Initial leer
        // Hier werden die globalen Zustände übernommen:
        includeSaturday: tempIncludeSaturday,
        includeSunday: tempIncludeSunday,
        includeHolidays: tempIncludeHolidays,
      };

      console.log("Daten für den POST-Request:", payload);

      // API-Aufruf zur Erstellung einer neuen Auftragsposition
      const response = await api.post(`/subscriptions/${subscriptionId}/subscriptionitems`, payload);
      console.log("API-Antwort nach Hinzufügen der Auftragsposition:", response.data);

      // Fetching der neuen Auftragspositionen nach dem Hinzufügen
      await fetchSubscriptionItems(); // Ruft die Liste erneut ab, um sicherzustellen, dass alles aktualisiert wird

      // Reset des ausgewählten Artikels und der Menge
      setSelectedItemId(null);
      setSelectedQuantity(1);
    } catch (error) {
      console.error('Fehler beim Hinzufügen der Auftragsposition:', error);
    }
  };

  const getUnitId = (item) => {
    // Überprüfe, ob eine Einheit im TypePricing existiert
    const typePricingUnitId = item?.machineType?.typePricings?.[0]?.unitId;

    // Falls keine Einheit im TypePricing gefunden, überprüfe das TransportPricing
    const transportUnitId = item?.transportPricings?.[0]?.unitId;

    // Setze die Einheit für Versicherungsartikel auf "Prozent" (id: 33)
    if (item?.itemType === 'insurance') {
      return 33;
    }

    // Wenn keine Einheit gefunden wurde, gebe null zurück
    return typePricingUnitId || transportUnitId || null;
  };

  const handleCheckboxChange = async (subscriptionItemId, field, value) => {
    try {
      // Aktualisieren des subscriptionItems-Zustands lokal
      const updatedSubscriptionItems = subscriptionItems.map(item => {
        if (item.id === subscriptionItemId) {
          return { ...item, [field]: value };
        }
        return item;
      });
      setSubscriptionItems(updatedSubscriptionItems);
      console.log(`Checkbox '${field}' für Auftragsposition ${subscriptionItemId} auf ${value} gesetzt.`);

      // Berechnung der rentalPeriodTo nach der Änderung
      updateRentalPeriodTo(updatedSubscriptionItems);

      // Speichern der Änderung im Backend
      const updatedItem = updatedSubscriptionItems.find(item => item.id === subscriptionItemId);
      if (updatedItem) {
        await api.put(`/subscriptions/${subscriptionId}/subscriptionitems/${subscriptionItemId}`, updatedItem);
        console.log(`Auftragsposition ${subscriptionItemId} erfolgreich aktualisiert.`);
      }
    } catch (error) {
      console.error(`Fehler beim Aktualisieren der Auftragsposition ${subscriptionItemId}:`, error);
      alert(`Fehler: Die Änderung an Auftragsposition ${subscriptionItemId} konnte nicht gespeichert werden.`);
    }
  };

  // Funktion zur globalen Aktualisierung der Checkbox-Zustände in allen subscriptionItems
  const handleGlobalCheckboxChange = async (field, value) => {
    try {
       // Setze den globalen Zustand
    if (field === 'includeSaturday') setTempIncludeSaturday(value);
    if (field === 'includeSunday') setTempIncludeSunday(value);
    if (field === 'includeHolidays') setTempIncludeHolidays(value);

    // Aktualisiere alle SubscriptionItems
      const updatedItems = subscriptionItems.map(item => ({
        ...item,
        [field]: value,
      }));

      console.log("Vor setSubscriptionItems (aktualisiert):", updatedItems);
      setSubscriptionItems(updatedItems);

      // Backend-Anfrage
      const updatePromises = updatedItems.map(item =>
        api.put(`/subscriptions/${subscriptionId}/subscriptionitems/${item.id}`, item)
      );
      await Promise.all(updatePromises);

      console.log("Nach Backend-Update erfolgreich!");
    } catch (error) {
      console.error(`Fehler beim Aktualisieren von ${field}:`, error);
    }
  };

  // Einheiten abrufen und im Zustand speichern
  const fetchUnits = async () => {
    try {
      const response = await api.get('/units'); // Beispiel-Endpoint zum Abrufen der Einheiten
      console.log("Geladene Einheiten:", response.data);
      setUnits(response.data); // Setze den Zustand für die Einheiten
    } catch (error) {
      console.error('Fehler beim Abrufen der Einheiten:', error);
    }
  };

  // useEffect, der die Berechnung von rentalPeriodTo auslöst, wenn sich subscriptionItems ändern
  useEffect(() => {
    if (subscriptionItems.length > 0) {
      updateRentalPeriodTo(); // Berechne rentalPeriodTo, wenn subscriptionItems sich ändern
    }
  }, [subscriptionItems]);

  // Auftragsposition bearbeiten
  const editSubscriptionItem = (subscriptionItemId) => {
    console.log("Edit-Handler aufgerufen mit ID:", subscriptionItemId);
    
    // Setze die ID der Zeile, die bearbeitet werden soll
    setEditingRowId(subscriptionItemId);

    // Finde die Auftragsposition
    const subscriptionItemToEdit = subscriptionItems.find((item) => item.id === subscriptionItemId);
    if (subscriptionItemToEdit) {
      // Setze die Daten für die Bearbeitung
      setSelectedItemId(subscriptionItemToEdit.itemId);
      setSelectedQuantity(subscriptionItemToEdit.quantity);

      // Achte darauf, dass auch die Einheit korrekt beibehalten wird
      setSelectedUnitId(subscriptionItemToEdit.unitId);  // Einheit bleibt erhalten

      // Temporäre Zustände für die Mietzeitfelder des subscriptionItems setzen
      setTempRentalPeriodFrom(subscriptionItemToEdit.rentalPeriodFrom || "");
      setTempRentalPeriodTo(subscriptionItemToEdit.rentalPeriodTo || "");
      setTempRentalTimeFrom(subscriptionItemToEdit.rentalTimeFrom || "");
      setTempRentalTimeTo(subscriptionItemToEdit.rentalTimeTo || "");

      // Initialisiere die temporären Checkboxwerte mit den subscriptionItem-Werten
      setTempIncludeSaturday(subscriptionItemToEdit.includeSaturday);
      setTempIncludeSunday(subscriptionItemToEdit.includeSunday);
      setTempIncludeHolidays(subscriptionItemToEdit.includeHolidays);
    } else {
      // Fehlerbehandlung
      console.error("Auftragsposition nicht gefunden:", subscriptionItemId);
      console.log("Aktuelle Auftragspositionen:", subscriptionItems); // Logge den Zustand von subscriptionItems
    }
  };

  /// Auftragsposition Einheit im Backend aktualisieren
  const saveSubscriptionItemUnit = async (subscriptionId, subscriptionItems) => {
    try {
      // Überprüfen, ob subscriptionId vorhanden ist
      if (!subscriptionId) {
        throw new Error("SubscriptionId ist nicht definiert");
      }

      // Überprüfen, ob subscriptionItems ein gültiges Array ist
      if (!Array.isArray(subscriptionItems) || subscriptionItems.length === 0) {
        throw new Error("SubscriptionItems ist nicht definiert oder kein gültiges Array");
      }

      // Optional: Jede Auftragsposition überprüfen, ob sie eine id und unitId hat
      subscriptionItems.forEach((item, index) => {
        if (!item.id) {
          throw new Error(`Fehlende id für Auftragsposition an Index ${index}: ${JSON.stringify(item)}`);
        }

        // Überprüfen, ob die Einheit korrekt gesetzt ist
        if (item.unitId === undefined || item.unitId === null) {
          throw new Error(`Fehlende unitId für Auftragsposition an Index ${index}: ${JSON.stringify(item)}`);
        }

        // Spezielle Behandlung für Versicherungsartikel (unitId muss 33 sein)
        if (item.itemType === 'insurance' && item.unitId !== 33) {
          item.unitId = 33;  // Setze die unitId auf 33 für Versicherungsartikel
        }
      });

      // Backend-URL korrekt formatieren und die Auftragspositionen als Array senden
      const response = await api.put(`/subscriptions/${subscriptionId}/subscriptionitems`, subscriptionItems);
      console.log(`Auftragspositionen erfolgreich gespeichert:`, response.data);

    } catch (error) {
      console.error(`Fehler beim Speichern der Auftragspositionen:`, error.message);
    }
  };

  const saveChanges = async () => {
    try {
      console.log('Speichere Daten der Auftragspositionen:', subscriptionItems);

      const updatePromises = subscriptionItems.map(async (item) => {
        const payload = {
          id: item.id,
          itemId: item.itemId,
          quantity: item.quantity,
          unitId: item.unitId,
          rentalPeriodFrom: item.rentalPeriodFrom,
          rentalPeriodTo: item.rentalPeriodTo,
          rentalTimeFrom: item.rentalTimeFrom,
          rentalTimeTo: item.rentalTimeTo,
          includeSaturday: item.includeSaturday,
          includeSunday: item.includeSunday,
          includeHolidays: item.includeHolidays,
          pricePerUnit: item.pricePerUnit,
          manualPriceActive: item.manualPriceActive,  // Das Flag mitübermitteln
          description: item.description,
        };

        try {
          const response = await api.put(
            `/subscriptions/${subscription.id}/subscriptionitems/${item.id}`,
            payload
          );
          if (response.status === 200 || response.status === 204) {
            console.log(`Position ${item.id} erfolgreich gespeichert.`);
          }
        } catch (err) {
          console.error(`Fehler beim Speichern der Position ${item.id}:`, err);
          throw new Error(`Fehler beim Speichern der Position ${item.id}`);
        }
      });

      await Promise.all(updatePromises);

      console.log('Alle Positionen erfolgreich gespeichert.');

      // Abrufen der aktuellen Positionen
      const updatedResponse = await api.get(`/subscriptions/${subscription.id}/subscriptionitems`);
      console.log('Backend-Daten vor Verarbeitung:', updatedResponse.data);

      if (Array.isArray(updatedResponse.data)) {
        setSubscriptionItems(updatedResponse.data);
        console.log('SubscriptionItems nach Backend-Synchronisation:', updatedResponse.data);
      }

      alert('Alle Änderungen wurden erfolgreich gespeichert!');
      setEditingRowId(null);
    } catch (error) {
      console.error('Fehler beim Speichern der Änderungen:', error);
      alert('Fehler: Änderungen konnten nicht gespeichert werden.');
    }
  };

  // Abbrechen der Bearbeitung
  const handleEditClick = (rowId) => {
    if (!subscriptionItems || subscriptionItems.length === 0) {
      console.warn("Keine SubscriptionItems verfügbar, um den Bearbeitungsmodus zu starten.");
      return;
    }

    console.log("Speichern der ursprünglichen SubscriptionItems vor Bearbeitung:", subscriptionItems);

    // Speichere die ursprünglichen SubscriptionItems als Kopie
    setOriginalSubscriptionItems([...subscriptionItems]);

    // Finde das SubscriptionItem, das bearbeitet wird, und setze die temporären Zustände
    const itemToEdit = subscriptionItems.find(item => item.id === rowId);
    if (itemToEdit) {
      console.log("Bearbeitung starten für:", itemToEdit);
      setSelectedItemId(itemToEdit.itemId);
      setSelectedQuantity(itemToEdit.quantity);

      // Temporäre Zustände für die Mietzeitfelder des subscriptionItems setzen
      setTempRentalPeriodFrom(itemToEdit.rentalPeriodFrom || "");
      setTempRentalPeriodTo(itemToEdit.rentalPeriodTo || "");
      setTempRentalTimeFrom(itemToEdit.rentalTimeFrom || "");
      setTempRentalTimeTo(itemToEdit.rentalTimeTo || "");

      // Initialisiere die temporären Checkboxwerte mit den subscriptionItem-Werten
      setTempIncludeSaturday(itemToEdit.includeSaturday);
      setTempIncludeSunday(itemToEdit.includeSunday);
      setTempIncludeHolidays(itemToEdit.includeHolidays);
    } else {
      console.warn(`Kein SubscriptionItem mit der ID ${rowId} gefunden.`);
    }

    setEditingRowId(rowId);
  };

  useEffect(() => {
    if (editingRowId) {
      console.log("Bearbeitungsmodus aktiviert. Speichere aktuelle SubscriptionItems:", subscriptionItems);
      setOriginalSubscriptionItems([...subscriptionItems]); // Kopie der aktuellen SubscriptionItems speichern
    }
  }, [editingRowId, subscriptionItems]);

  const handleCancelEdit = () => {
    console.log("Abbrechen gedrückt. Original SubscriptionItems:", originalSubscriptionItems);

    if (!originalSubscriptionItems || originalSubscriptionItems.length === 0) {
      console.warn("Keine Originaldaten zum Zurücksetzen gefunden.");
      return;
    }

    // Setze subscriptionItems auf die ursprünglichen Werte zurück
    setSubscriptionItems([...originalSubscriptionItems]);
    console.log("SubscriptionItems nach Abbrechen zurückgesetzt auf:", originalSubscriptionItems);

    // Beende den Bearbeitungsmodus
    setEditingRowId(null);
  };

  const handleSaveEditedSubscriptionItem = async () => {
    try {
      // Aktualisieren der subscriptionItems mit den temporären Zuständen
      const updatedSubscriptionItems = subscriptionItems.map(item => {
        if (item.id === editingRowId) {
          return {
            ...item,
            includeSaturday: tempIncludeSaturday,
            includeSunday: tempIncludeSunday,
            includeHolidays: tempIncludeHolidays,
          };
        }
        return item;
      });

      // Führen Sie die Berechnung durch
      updateRentalPeriodTo(updatedSubscriptionItems);

      // Speichern Sie alle subscriptionItems im Backend
      const updatePromises = updatedSubscriptionItems.map(item =>
        api.put(`/subscriptions/${subscriptionId}/subscriptionitems/${item.id}`, item)
      );
      await Promise.all(updatePromises);

      // Aktualisieren Sie den Frontend-Zustand nach erfolgreichem Speichern
      setSubscriptionItems(updatedSubscriptionItems);

      // Beenden Sie den Bearbeitungsmodus
      setEditingRowId(null);

      alert('Alle Änderungen wurden erfolgreich gespeichert!');
    } catch (error) {
      console.error('Fehler beim Speichern der bearbeiteten Auftragsposition:', error);
      alert('Fehler: Die bearbeiteten Änderungen konnten nicht gespeichert werden.');
    }
  };

  const calculatePrice = (itemObj, quantity) => {
    let pricePerUnit = 0;
    let total = 0;

    if (itemObj.item?.machineType?.typePricings) {
      // Beispielhafte Preisstaffelungslogik
      const pricing = itemObj.item.machineType.typePricings.find(
        (p) => quantity >= p.minQuantity && quantity <= p.maxQuantity
      );
      if (pricing) {
        pricePerUnit = parseFloat(pricing.pricePerUnit);
        total = parseFloat((pricePerUnit * quantity).toFixed(2));
      }
    } else if (itemObj.item?.transportPricings?.[0]?.pricePerUnit) {
      pricePerUnit = parseFloat(itemObj.item.transportPricings[0].pricePerUnit);
      total = parseFloat((pricePerUnit * quantity).toFixed(2));
    }

    return { pricePerUnit, total };
  };

  const fetchFilteredItems = debounce(async (searchTerm) => {
    try {
      const response = await api.get(`/items?search=${searchTerm}`);
      // Auch hier nur aktive Artikel anzeigen
      const activeItems = response.data.filter(item => item.deactivated === false);
      setItems(activeItems); // Aktualisiere die Artikel-Liste mit den gefilterten Artikeln
    } catch (error) {
      console.error('Fehler beim Filtern der Artikel:', error);
    }
  }, 300); // 300ms Verzögerung

  const handleItemSearchChange = (inputValue) => {
    if (inputValue.trim() === '') {
      setItems([]); // Leere Liste, wenn keine Eingabe
      return;
    }

    fetchFilteredItems(inputValue); // Filtere Artikel basierend auf dem Suchbegriff
  };

 // Optionen für `react-select` transformieren
const formatItemOptionLabel = (item) => {
  const description = String(item?.description || '').trim();
  return `${item.name}${description ? ` - ${description}` : ''} (${item.itemType})`;
};

  const allowedTypes = ['rental', 'sale', 'service', 'sparePart', 'transport']; 
const filteredItems = items.filter(item => allowedTypes.includes(item.itemType));

const itemOptions = filteredItems.map(item => ({
  value: item.id,
  label: formatItemOptionLabel(item)
}));

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [lwOperatorContacts, setLWOperatorContacts] = useState([]); // State für Ansprechpartner vor Ort (LW-Bediener)
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedLWOperator, setSelectedLWOperator] = useState(null); // State für den ausgewählten Ansprechpartner vor Ort
  const [isLoading, setIsLoading] = useState(true);
  const [contactsLoadedForCustomer, setContactsLoadedForCustomer] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Kunden laden (nur einmal beim initialen Rendern)
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        console.log("Kunden werden geladen...");
        const customersResponse = await api.get("/customers");
        const loadedCustomers = customersResponse.data;
        setCustomers(loadedCustomers);
        setFilteredCustomers(loadedCustomers); // Zu Beginn alle Kunden anzeigen
        console.log("Kunden geladen:", loadedCustomers);
      } catch (error) {
        console.error("Fehler beim Laden der Kunden:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Funktion, um die Kontakte eines bestimmten Kunden zu laden
  const loadContactsForCustomer = useCallback(async (customerId, contactId = null) => {
    try {
      if (!customerId || customerId === contactsLoadedForCustomer) return;

      console.log(`Lade Kontakte für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=Besteller`
      );
      setCustomerContacts(response.data);
      setContactsLoadedForCustomer(customerId);
      console.log("Kontakte geladen:", response.data);

      if (contactId) {
        const selectedContact = response.data.find(
          (contact) => contact.id.toString() === contactId.toString()
        );
        if (selectedContact) {
          setSelectedContact(selectedContact);
          console.log("Ausgewählter Besteller gesetzt:", selectedContact);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der Besteller:", error);
    }
  }, [contactsLoadedForCustomer]);

  // Funktion, um die LW-Bediener-Kontakte eines bestimmten Kunden zu laden
  const loadLWOperatorContacts = useCallback(async (customerId, lwOperatorId = null) => {
    try {
      if (!customerId) return;

      console.log(`Lade LW-Bediener für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=LW-Bediener`
      );
      setLWOperatorContacts(response.data);
      console.log("LW-Bediener geladen:", response.data);

      if (lwOperatorId) {
        const selectedLWOperator = response.data.find(
          (contact) => contact.id.toString() === lwOperatorId.toString()
        );
        if (selectedLWOperator) {
          setSelectedLWOperator(selectedLWOperator);
          console.log("Ausgewählter Ansprechpartner vor Ort gesetzt:", selectedLWOperator);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der LW-Bediener:", error);
    }
  }, [setLWOperatorContacts]);

  // Auftrag und zugehörige Daten laden, falls im Bearbeitungsmodus
  useEffect(() => {
    if (mode === "edit" && subscriptionId && customers.length > 0 && !initialDataLoaded) {
      const fetchSubscriptionData = async () => {
        try {
          console.log("Auftrag wird geladen...");
          const subscriptionResponse = await api.get(`/subscriptions/${subscriptionId}`);
          const fetchedSubscription = subscriptionResponse.data;

          console.log("Geladener Auftrag:", fetchedSubscription);

          setSubscription({
            ...fetchedSubscription,
            rentalPeriodFrom: normalizeDate(fetchedSubscription.rentalPeriodFrom),
            rentalPeriodTo: normalizeDate(fetchedSubscription.rentalPeriodTo),
          });

          console.log("Auftrag gesetzt:", fetchedSubscription);

          if (fetchedSubscription.customerId) {
            const selectedCustomer = customers.find(
              (customer) => customer.id.toString() === fetchedSubscription.customerId.toString()
            );
            if (selectedCustomer) {
              setSelectedCustomer(selectedCustomer);
              console.log("Ausgewählter Kunde gesetzt:", selectedCustomer);
              // Kontakte und LW-Bediener nur einmal laden
              await loadContactsForCustomer(fetchedSubscription.customerId, fetchedSubscription.contactId);
              await loadLWOperatorContacts(fetchedSubscription.customerId, fetchedSubscription.lwOperatorId);
            }
          }
        } catch (error) {
          console.error("Fehler beim Laden des Auftrags:", error);
        } finally {
          setInitialDataLoaded(true);
          setIsLoading(false);
        }
      };

      fetchSubscriptionData();
    } else {
      setIsLoading(false);
    }
  }, [mode, subscriptionId, customers, initialDataLoaded, loadContactsForCustomer, loadLWOperatorContacts]);

  // Funktion, um das Datum zu normalisieren
  const normalizeDate = (dateString) => dateString?.split("T")[0] || "";

  // Funktion zum Filtern der Kunden (debounced, um unnötige Anfragen zu vermeiden)
  const filterCustomers = debounce((inputValue) => {
    if (inputValue.trim() === "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter((customer) =>
        `${customer.company} ${customer.customerNumber} ${customer.firstName} ${customer.lastName} ${customer.street} ${customer.postalCode} ${customer.city}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, 300);

  // Handle search field changes
  const handleCustomerSearchChange = (inputValue) => {
    filterCustomers(inputValue);
  };

  // Auftrag auswählen und alle zugehörigen Daten laden
  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setSubscription((prev) => ({
        ...prev,
        customerId: "",
        contactId: "", // Kontakt ebenfalls zurücksetzen
        lwOperatorId: "", // Ansprechpartner vor Ort zurücksetzen
      }));
      setSelectedCustomer(null);
      setCustomerContacts([]);
      setSelectedContact(null);
      setLWOperatorContacts([]);
      setSelectedLWOperator(null);
      return;
    }

    const selectedCustomerId = selectedOption.value;

    // Den neuen Kunden setzen und Besteller zurücksetzen
    setSubscription((prev) => ({
      ...prev,
      customerId: selectedCustomerId,
      contactId: "", // Zurücksetzen des Bestellers, da der Kunde geändert wurde
      lwOperatorId: "", // Zurücksetzen des LW-Bedieners
    }));

    // Den ausgewählten Kunden im Zustand speichern und anzeigen
    const selected = customers.find(
      (customer) => customer.id.toString() === selectedCustomerId.toString()
    );
    if (selected) {
      setSelectedCustomer(selected);
      console.log("Ausgewählter Kunde geändert:", selected);
      // Kontakte für den neuen Kunden laden
      loadContactsForCustomer(selectedCustomerId);
      loadLWOperatorContacts(selectedCustomerId);
    } else {
      setSelectedCustomer(null);
      console.log("Kunde konnte nicht gefunden werden");
    }
  };

  // Funktion zum Aktualisieren von Feldern (z.B. date, deliveryTime, etc.)
  const handleChange = (e) => {
    const { name, value } = e.target;

    setSubscription(prev => {
      const updatedSubscription = {
        ...prev,
        [name]: value, // Aktualisiere das geänderte Feld
      };

      // Wenn rentalPeriodFrom geändert wurde, berechne rentalPeriodTo
      if (name === 'rentalPeriodFrom') {
        updateRentalPeriodTo(); // Berechne rentalPeriodTo basierend auf rentalPeriodFrom
      }

      return updatedSubscription;
    });
  };

  // Besteller ändern
  const handleContactChange = (e) => {
    const selectedContactId = e.target.value;
    setSubscription((prev) => ({
      ...prev,
      contactId: selectedContactId,
    }));

    const selected = customerContacts.find(
      (contact) => contact.id.toString() === selectedContactId.toString()
    );
    if (selected) {
      setSelectedContact(selected);
      console.log("Ausgewählter Besteller geändert:", selected);
    } else {
      setSelectedContact(null);
      console.log("Besteller konnte nicht gefunden werden");
    }
  };

  // Ansprechpartner vor Ort ändern
  const handleLWOperatorChange = (e) => {
    const selectedLWOperatorId = e.target.value;
    setSubscription((prev) => ({
      ...prev,
      lwOperatorId: selectedLWOperatorId,
    }));

    const selected = lwOperatorContacts.find(
      (contact) => contact.id.toString() === selectedLWOperatorId.toString()
    );
    if (selected) {
      setSelectedLWOperator(selected);
      console.log("Ausgewählter Ansprechpartner vor Ort geändert:", selected);
    } else {
      setSelectedLWOperator(null);
      console.log("Ansprechpartner vor Ort konnte nicht gefunden werden");
    }
  };

  // Funktion, um Gesamtsummen zu berechnen und im Backend zu speichern
  const saveSubscriptionTotals = async () => {
    const totalNet = subscriptionItems.reduce((sum, item) => sum + (item.total || 0), 0); // Summe der Netto-Werte
    const vatRate = subscription.vatRate ?? 19; // MwSt.-Satz aus dem Auftrag oder Standardwert
    const vatAmount = totalNet * (vatRate / 100); // Berechnung der MwSt.
    const totalGross = totalNet + vatAmount; // Brutto = Netto + MwSt.

    try {
      await api.put(`/subscriptions/${subscription.id}`, {
        taxTreatment: subscription.taxTreatment,
        taxNote: subscription.taxNote,
        totalNet,
        vatAmount,
        totalGross,
      });
      console.log('Gesamtsummen erfolgreich gespeichert.');
    } catch (error) {
      console.error('Fehler beim Speichern der Gesamtsummen:', error);
      alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
    }
  };

  const updateSubscriptionAndSaveTotals = async () => {
    // Zuerst die SubscriptionItems aktualisieren
    const subscriptionItemsUpdateResponse = await api.put(
      `/subscriptions/${subscription.id}/subscriptionitems`, 
      subscriptionItems
    );

    // Berechnung der neuen Gesamtsumme
    const totalNet = subscriptionItems.reduce((sum, item) => sum + (item.total || 0), 0);
    const vatRate = subscription.vatRate ?? 19;
    const vatAmount = totalNet * (vatRate / 100);
    const totalGross = totalNet + vatAmount;

    // Danach die Subscription-Tabelle mit den neuen Gesamtwerten aktualisieren
    try {
      const response = await api.put(`/subscriptions/${subscription.id}`, {
        taxTreatment: subscription.taxTreatment,
        taxNote: subscription.taxNote,
        totalNet,
        vatAmount,
        totalGross,
      });
      console.log('Gesamtsummen erfolgreich gespeichert:', response.data);
    } catch (error) {
      console.error('Fehler beim Speichern der Gesamtsummen:', error);
      alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
    }
  };

  const handleBackButtonClick = async () => {
    if (await saveSubscriptionTotals() === false) return; // Speichern der Gesamtsummen
    navigate('/subscriptionlist'); // Zurück zur Auftragsübersicht
  };

  // Auftrag speichern
  const handleSave = async () => {
    if (!subscription.customerId) {
      alert("Bitte wählen Sie einen Kunden aus.");
      return;
    }
    
    console.log("Auftrag, der gespeichert wird:", subscription);

    try {
      const subscriptionDate = subscription.date || new Date().toISOString(); // Setze das Auftragsdatum, falls es nicht existiert
      const validUntilDate = subscription.validUntil || new Date(new Date(subscriptionDate).setDate(new Date(subscriptionDate).getDate() + 14)).toISOString(); // Setze Auftragsgültigkeit, falls nicht vorhanden

      // Wenn der Auftrag im Draft-Status ist, setzen wir beim Speichern den Status auf 'pending',
      // damit im Backend die Auftragsnummer vergeben wird.
      const finalStatus = subscription.status === 'draft' ? 'pending' : subscription.status;

    
      const payload = {
        ...subscription,
        date: subscriptionDate,
        validUntil: validUntilDate,
        contactId: subscription.contactId || null,
        lwOperatorId: subscription.lwOperatorId || null,
        status: finalStatus,
        includeSaturday: subscription.includeSaturday,  // Globalen Zustand integrieren
      includeSunday: subscription.includeSunday,
      includeHolidays: subscription.includeHolidays,
      subscriptionType: subscription.subscriptionType || 'standard',
      };

      if (mode === "edit") {
        await api.put(`/subscriptions/${subscriptionId}`, payload);
        alert("Subcription erfolgreich aktualisiert!");
      } else {
        const response = await api.post("/subscriptions", payload);
        alert(`Subcription erfolgreich erstellt! Subcriptionnummer: ${response.data.subscriptionNumber}`);
      }

      // Gesamtsummen-Funktion aufrufen
      await saveSubscriptionTotals();

      if (onSave) onSave();
      navigate("/subscriptionlist");
    } catch (error) {
      console.error("Fehler beim Speichern der Subcription:", error);
      alert(error.response?.data?.error || "Der Beleg konnte nicht gespeichert werden.");
    }
  };

  // Kundenoptionen für React Select
  const customerOptions = filteredCustomers.map((customer) => ({
    value: customer.id,
    label: `${customer.company} (${customer.customerNumber})`,
  }));

  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div key={subscriptionId} className="subscription-form-container">
       <Helmet>
        <title>Subscription bearbeiten</title>
        <meta name="description" content="Subscription bearbeiten" />
      </Helmet>
      <h1>{mode === "edit" ? "Subscription bearbeiten" : "Neue Subscription erstellen"}</h1>

      <div className="form-row">
        {/* Linke Spalte - Adressblock */}
        <div className="col">
          <label htmlFor="customerId" className="full-width">
            Kunde auswählen:
            <Select
              id="customerId"
              name="customerId"
              options={customerOptions}
              onInputChange={handleCustomerSearchChange}
              onChange={handleCustomerChange}
              value={customerOptions.find(option => option.value === subscription.customerId) || null}
              className="select-box-cst"
              isClearable
              placeholder="Kunde suchen..."
            />
          </label>

          {/* Adressblock - Anzeige der Kundendaten */}
          {selectedCustomer && (
            <div className="customer-details">
              <p><strong>Firma:</strong> {selectedCustomer.company}</p>
              <p><strong>Zusatz:</strong> {selectedCustomer.companyAddon}</p>
              <p><strong>Anrede:</strong> {selectedCustomer.salutation} {selectedCustomer.firstName} {selectedCustomer.lastName}</p>
              <p><strong>Adresse:</strong> {selectedCustomer.street}, {selectedCustomer.postalCode} {selectedCustomer.city}</p>
              <TaxTreatmentFields document={subscription} onChange={setSubscription} customer={selectedCustomer} />

             

              <div className="checkbox-group" style={{ marginTop: '20px' }}>
  <div
    className="checkbox-list"
    style={{
      display: 'flex',
      flexDirection: 'column',    // <–– Items untereinander
      alignItems: 'center',       // <–– zentriert
      gap: '12px',                // <–– Abstand zwischen den Zeilen
      marginTop: '20px'
    }}
  >
    <label htmlFor="smartRental" className="checkbox-item">
      <input
        type="checkbox"
        id="smartRental"
        name="smartRental"
        checked={subscription.smartRental}
        onChange={e =>
          setSubscription(prev => ({ ...prev, smartRental: e.target.checked }))
        }
      />
      SmartRental
    </label>

    <label htmlFor="obligationInstruction" className="checkbox-item">
      <input
        type="checkbox"
        id="obligationInstruction"
        name="obligationInstruction"
        checked={subscription.obligationInstruction}
        onChange={e =>
         setSubscription(prev => ({ ...prev, obligationInstruction: e.target.checked }))
        }
      />
      Unterwpflicht
    </label>
  </div>
</div>



{/* Transportnotiz */}
<label htmlFor="notes" className="full-width" style={{ marginTop: '15px' }}>
              
              <textarea
                id="transportNotes"
                name="transportNotes"
                value={subscription.transportNotes}
                onChange={handleChange}
                className="textarea-notes"
                rows="6"
                style={{ width: '60%', marginBottom: '20px', marginTop: '20px' }} // Breite kann hier angepasst werden
                placeholder="Transportnotiz"
              />
            </label>

 {/* --- NEU: SubscriptionType-Auswahl (oberhalb der Bestellnummer) --- */}
<label
  htmlFor="subscriptionType"
  className="full-width"
  style={{
    display: 'block',
    width: '100%',
    marginTop: '10px',
    marginBottom: '15px',
    textAlign: 'center'   // Inhalt zentrieren
  }}
>
  <strong>Subscription-Typ</strong>
  <br />
  <select
    id="subscriptionType"
    name="subscriptionType"
    value={subscription.subscriptionType || 'standard'}
    onChange={(e) =>
      setSubscription((prev) => ({
        ...prev,
        subscriptionType: e.target.value
      }))
    }
    style={{
      display: 'block',
      padding: '10px',
      borderRadius: '4px',
      border: '1px solid #ccc',
      cursor: 'pointer',
      width: '250px',
      margin: '6px auto 0 auto'   // Select mittig platzieren
    }}
  >
    <option value="standard">Standard</option>
    <option value="offerCampaign">Offer-Kampagne</option>
  </select>
</label>


            </div>
          )}

        </div>

      
        {/* Mittlere Spalte - Mietzeitraum */}
        <div className="col">
          
          <div>
            

            {/* Anlieferzeit Feld */}
            <label htmlFor="deliveryTime" className="full-width">
              Anlieferzeit:
              <input
                type="time"
                id="deliveryTime"
                name="deliveryTime"
                value={subscription.deliveryTime || ""}
                onChange={handleChange}
                className="input-box"
              />
            </label>

            {/* Einsatzort (operationLocation) */}
            <label htmlFor="operationLocation" className="full-width">
              Einsatzort:
              <input
                type="text"
                id="operationLocation"
                name="operationLocation"
                value={subscription.operationLocation || ""}
                onChange={handleChange}
                className="input-box"
                placeholder="Strasse, PLZ, Ort"
              />
            </label>

            {/* Ansprechpartner vor Ort */}
            <label htmlFor="lwOperatorId" className="full-width">
              Ansprechpartner vor Ort:
              <select
                id="lwOperatorId"
                name="lwOperatorId"
                value={subscription.lwOperatorId}
                onChange={handleLWOperatorChange}
                className="select-box"
                style={{ marginLeft: '0px' }}
              >
                <option value="">Bitte Ansprechpartner vor Ort wählen</option>
                {lwOperatorContacts.map((contact) => (
                  <option key={contact.id} value={contact.id}>
                    {contact.contactFirstName} {contact.contactLastName}
                  </option>
                ))}
              </select>
            </label>

             {/* Checkboxen unterhalb des Bestellers */}
             <div className="checkbox-group" >
                 <h3>Als regulärer Miettag zählen:</h3>
                <div className="checkbox-list">
                  {/* Samstag Checkbox */}
                 <label htmlFor="includeSaturday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSaturday"
            name="includeSaturday"
            checked={tempIncludeSaturday}
            onChange={e =>
              handleGlobalCheckboxChange("includeSaturday", e.target.checked)
            }
            disabled={!isEditing}
          />
          Samstag
        </label>
                

                  {/* Sonntag Checkbox */}
                  <label htmlFor="includeSunday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSunday"
            name="includeSunday"
            checked={tempIncludeSunday}
            onChange={e =>
              handleGlobalCheckboxChange("includeSunday", e.target.checked)
            }
            disabled={!isEditing}
          />
          Sonntag
        </label>

                  {/* Feiertage Checkbox */}
                  <label htmlFor="includeHolidays" className="checkbox-item">
          <input
            type="checkbox"
            id="includeHolidays"
            name="includeHolidays"
            checked={tempIncludeHolidays}
            onChange={e =>
              handleGlobalCheckboxChange("includeHolidays", e.target.checked)
            }
            disabled={!isEditing}
          />
          Feiertage
        </label>

                </div>

                {/* Neue Checkbox für Reservierung (falls benötigt, sonst entfernen) */}
                {/* Entfernt, da Subscriptions keine Reservierung sind */}
              </div>
            
            {/* Auftragsnotiz */}
            <label htmlFor="notes" className="full-width" style={{ marginTop: '15px' }}>
              
              <textarea
                id="notes"
                name="notes"
                value={subscription.notes}
                onChange={handleChange}
                className="textarea-notes"
                rows="7"
                style={{ width: '98%', marginBottom: '150px', marginTop: '20px' }} // Breite kann hier angepasst werden
                placeholder="Abonotiz"
              />
            </label>
          </div>
           <div className="col"></div>
          {/* Auftragspositionen */}
          <div className="table-breakout" style={{ marginTop: '70px' }}>
            <h3>Auftragspositionen</h3>

            <table className="subscription-positions-table" >
              <thead>
                <tr>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Position</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Artikel</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Beschreibung</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Einheit</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Menge</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>E-Preis</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Gesamt</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Zeit Von</th>
                  <th>Zeit Bis</th>
                  <th style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionItems.map((position, index) => {
                  const isRental = position.item?.itemType === 'rental';
                  const isInsuranceItem = position.item?.itemType === 'insurance';
                  const isInsuranceFixedItem = position.item?.itemType === 'insuranceFixed';
                  const editingThisRow = editingRowId === position.id;

                  const unitName =
                    position.item?.machineType?.typePricings?.[0]?.unit?.name ||
                    position.item?.transportPricings?.[0]?.unit?.name ||
                    (isInsuranceItem ? 'Prozent' : 'n.a.');

                  let pricePerUnit = 0;
                  let total = 0;

                  // MBV-Berechnung
                  if (isInsuranceItem) {
                    const mainItem = subscriptionItems.find(
                      (item) => item.id === position.mainItemId
                    );

                    if (mainItem) {
                      const insurancePercentage = position.quantity;
                      const mbvPricePerUnit = (mainItem.pricePerUnit * insurancePercentage) / 100;
                      const mbvTotal = mbvPricePerUnit * mainItem.quantity;

                      pricePerUnit = mbvPricePerUnit;
                      total = mbvTotal;
                    }
                  } else if (position.pricePerUnit && position.quantity) {
                    pricePerUnit = position.pricePerUnit;
                    total = (position.quantity * position.pricePerUnit);
                  }

                  const isLinkedItem = !!position.mainItemId;

                  // Formatierung des Einzelpreises
                  const formattedPricePerUnit = (typeof pricePerUnit === 'number' && !isNaN(pricePerUnit))
                    ? pricePerUnit.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  // Formatierung des Gesamtpreises
                  const formattedTotal = (typeof total === 'number' && !isNaN(total))
                    ? total.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  return (
                    <tr key={position.id} style={isLinkedItem ? { paddingLeft: '20px' } : {}}>
                      {/* Positionsnummer */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>{index + 1}</td>

                      {/* Artikelname */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <input
                            type="text"
                            value={position.item?.name || ''}
                            onChange={(e) =>
                              setSubscriptionItems((prev) =>
                                prev.map((item) =>
                                  item.id === position.id
                                    ? { ...item, item: { ...item.item, name: e.target.value } }
                                    : item
                                )
                              )
                            }
                          />
                        ) : (
                          position.item?.name
                        )}
                      </td>

                      {/* Beschreibung */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
    <textarea
      value={position.description ?? position.item?.description ?? ''}
      onChange={(e) =>
        setSubscriptionItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { ...item, description: e.target.value }
              : item
          )
        )
      }
    />
  ) : (
    position.description || position.item?.description || 'Keine Beschreibung verfügbar'
  )}
</td>

                      {/* Einheit */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <>

                            <select
                              value={position.unitId != null ? position.unitId.toString() : ''} // Zeige die aktuelle Einheit, nicht "Einheit wählen"
                              onChange={(e) => {
                                const newUnitId = e.target.value ? parseInt(e.target.value, 10) : null;

                                // Setze die neue Einheit im Zustand, wenn die Einheit geändert wird
                                setSubscriptionItems((prev) =>
                                  prev.map((item) =>
                                    item.id === position.id
                                      ? { ...item, unitId: newUnitId } // Aktualisiere die Einheit für diese Position
                                      : item
                                  )
                                );

                                // Speichern der geänderten Einheit im Backend
                                saveSubscriptionItemUnit(position.id, newUnitId);
                              }}
                            >
                              <option value="">Einheit wählen</option>
                              {position.item?.machineType?.typePricings
                                ?.map((pricing) => pricing.unit) // Alle verfügbaren Einheiten
                                ?.filter((unit, index, self) => unit && self.findIndex((u) => u.id === unit.id) === index) // Verhindere doppelte Einheiten
                                .map((unit) => (
                                  <option key={unit.id} value={unit.id.toString()}>
                                    {unit.name}
                                  </option>
                                ))}
                            </select>
                          </>
                        ) : (
                          position.unit?.name || '' // Zeige die Einheit im normalen Modus
                        )}
                      </td>

                      {/* Menge */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                       {editingThisRow && !isInsuranceItem && !isInsuranceFixedItem ? (
                          <input
                            type="number"
                            value={position.quantity || ''}
                            onChange={(e) =>
                              setSubscriptionItems((prev) =>
                                prev.map((item) =>
                                  item.id === position.id
                                    ? { ...item, quantity: parseFloat(e.target.value) || 0 }
                                    : item
                                )
                              )
                            }
                            min="0"
                          />
                         ) : isInsuranceItem ? (
    // Prozent-Versicherung
    `${position.quantity}%`
  ) : isInsuranceFixedItem ? (
    // Fixed-Insurance: nur Zahl anzeigen (read-only)
    position.quantity
  ) : (
    // alle anderen Typen
    position.quantity
  )}
                      </td>

                      {/* Einzelpreis */}
<td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <input
      type="number"
      value={position.pricePerUnit || ''}
      onChange={(e) =>
        setSubscriptionItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { 
                  ...item, 
                  pricePerUnit: parseFloat(e.target.value) || 0,
                  manualPriceActive: true  // Flag setzen, wenn der Preis geändert wurde
                }
              : item
          )
        )
      }
      min="0"
      step="0.01"
    />
  ) : (
    // Formatierung des Einzelpreises mit Komma und Euro-Symbol
    (typeof position.pricePerUnit === 'number' && !isNaN(position.pricePerUnit))
      ? position.pricePerUnit.toFixed(2).replace('.', ',') + ' €'
      : '0,00 €'
  )}
</td>

                      {/* Gesamtpreis */}
                      <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                          {typeof total === 'number' && !isNaN(total)
                            ? total.toFixed(2).replace('.', ',') + ' €'
                            : '0,00 €'}
                        </td>
                        {isRental && (
                        <>
                           {/* Mietzeitraum Von */}
                          <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                          {editingThisRow && !isInsuranceItem ? (
                              <input
                                type="date"
                                value={position.rentalPeriodFrom || ''}
                                onChange={(e) =>
                                  setSubscriptionItems((prev) =>
                                    prev.map((item) =>
                                      item.id === position.id
                                        ? { ...item, rentalPeriodFrom: e.target.value }
                                        : item
                                    )
                                  )
                                }
                              />
                            ) : (
                              position.rentalPeriodFrom ? formatDate(position.rentalPeriodFrom) : '-'
                            )}
                          </td>

                           {/* Mietzeitraum Bis */}
<td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <input
      type="date"
      value={position.rentalPeriodTo || ''}
      readOnly // Verhindert Benutzereingaben
      style={{
        backgroundColor: '#f5f5f5', // Optional: Zeigt visuell an, dass das Feld nicht bearbeitet werden kann
        cursor: 'not-allowed', // Zeigt einen visuellen Hinweis an, dass das Feld gesperrt ist
      }}
    />
  ) : (
    position.rentalPeriodTo ? formatDate(position.rentalPeriodTo) : '-'
  )}
</td>

                          {/* Mietzeit Von */}
                          <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                          {editingThisRow && !isInsuranceItem ? (
                              <input
                                type="time"
                                value={position.rentalTimeFrom || ''}
                                onChange={(e) => {
                                  console.log('Änderung in rentalTimeFrom:', e.target.value); // Debugging
                                  setSubscriptionItems((prev) =>
                                    prev.map((item) =>
                                      item.id === position.id
                                        ? { ...item, rentalTimeFrom: e.target.value }
                                        : item
                                    )
                                  );
                                }}
                              />
                            ) : (
                              position.rentalTimeFrom || '-'
                            )}
                          </td>

                          {/* Mietzeit Bis */}
                          <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                          {editingThisRow && !isInsuranceItem ? (
                              <input
                                type="time"
                                value={position.rentalTimeTo || ''}
                                onChange={(e) =>
                                  setSubscriptionItems((prev) =>
                                    prev.map((item) =>
                                      item.id === position.id
                                        ? { ...item, rentalTimeTo: e.target.value }
                                        : item
                                    )
                                  )
                                }
                              />
                            ) : (
                              position.rentalTimeTo || '-'
                            )}
                          </td>
                        </>
                      )}

                     {/* Aktionen */}
                     <td style={{ bsubscription: '1px solid #ddd', padding: '8px' }}>
                     {editingThisRow ? (
                          <div style={{ display: 'flex' }}>
                            <button
                              type="button"
                              onClick={() => {
                                saveChanges();
                                setEditingRowId(null);
                              }}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#28a745',
                                color: '#fff',
                                bsubscription: 'none',
                                bsubscriptionRadius: '5px',
                              }}
                            >
                              Speichern
                            </button>
                            <button
                              type="button"
                              onClick={handleCancelEdit}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#6c757d',
                                color: '#fff',
                                bsubscription: 'none',
                                bsubscriptionRadius: '5px',
                                marginLeft: '10px',
                              }}
                            >
                              Abbrechen
                            </button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex' }}>
                            {/* Verstecke/Deaktiviere den Bearbeiten-Button, falls insurance */}
            { !isInsuranceItem
   && position.item?.itemType !== 'insuranceFixed' && (
                            <button
                type="button"
                onClick={() => setEditingRowId(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#007bff',
                  color: '#fff',
                  bsubscription: 'none',
                  bsubscriptionRadius: '5px',
                  marginRight: '10px',
                }}
              >
                Bearbeiten
              </button>
              )}
                            <button
                              type="button"
                              onClick={() => removeSubscriptionItem(position.id)}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#dc3545',
                                color: '#fff',
                                bsubscription: 'none',
                                bsubscriptionRadius: '5px',
                              }}
                            >
                              Löschen
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>

            {/* Gesamtsummen-Tabelle */}
            <div style={{ marginTop: '20px', width: '100%', maxWidth: '800px' }}>
              <h3>Zusammenfassung</h3>
              <table style={{ bsubscriptionCollapse: 'collapse', width: '100%' }}>
                <tbody>
                  {/* Gesamt Netto */}
                  <tr>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>Gesamt Netto</td>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung von totalNet */}
                      {(subscriptionItems.reduce((sum, item) => sum + (item.total || 0), 0).toFixed(2).replace('.', ',') || '0,00') + ' €'}
                    </td>
                  </tr>

                  {/* MwSt. */}
                  <tr>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>zzgl. MwSt. ({subscription.vatRate ?? 19}%)</td>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung der MwSt. */}
                      {(
                        subscriptionItems.reduce((sum, item) => sum + (item.total || 0), 0) *
                        ((subscription.vatRate ?? 19) / 100)
                      ).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>

                  {/* Brutto */}
                  <tr>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>Rechnungsbetrag</td>
                    <td style={{ bsubscription: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung des Bruttobetrags */}
                      {(
                        subscriptionItems.reduce((sum, item) => sum + (item.total || 0), 0) *
                        (1 + ((subscription.vatRate ?? 19) / 100))
                      ).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>
                </tbody>
              </table>
            
          </div>

          {/* Neue Auftragsposition hinzufügen */}
          <div className="subscription-item-addition" style={{ marginTop: '20px' }}>
            <h3>Neue Auftragsposition hinzufügen</h3>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="quantity">Menge:</label>
              <input
                type="number"
                id="quantity"
                value={selectedQuantity}
                onChange={(e) => setSelectedQuantity(e.target.value)}
                min="1"
                style={{ display: 'block', marginTop: '5px', marginBottom: '10px',  padding: '8px', width: '100%', marginLeft: '0px'}}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="itemId"></label>
              <Select
                 id="itemId"
                options={itemOptions}
                value={
                  items
                    .map((item) => ({ value: item.id, label: formatItemOptionLabel(item) }))
                    .find((option) => option.value === selectedItemId) || null
                } // Aktuell ausgewählt
                onChange={(selectedOption) => setSelectedItemId(selectedOption ? selectedOption.value : null)} // Auswahl speichern
                onInputChange={(inputValue) => fetchFilteredItems(inputValue)} // Filterfunktion
                placeholder="Artikel suchen..."
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    marginTop: '10px',
                    width: '100%',
                  
                  }),
                }}
              />
            </div>
            
            <button type="button" onClick={addSubscriptionItem} style={{ padding: '10px 20px', cursor: 'pointer' }}>
              Auftragsposition hinzufügen
            </button>
          </div>
        </div>

        {/* Rechte Spalte - Auftragsnummer und Besteller */}
        <div className="col">

          

          

           {/* Dropdown-Feld für Rechnungen */}
{subscription.invoices && subscription.invoices.filter(inv => !inv.creditNotes || inv.creditNotes.length === 0).length > 0 && (
  <div style={{ marginBottom: '20px' }}>
    <label htmlFor="invoiceDropdown" style={{ marginRight: '10px', fontWeight: 'bold' }}>
      
    </label>
    <select
      id="invoiceDropdown"
      onChange={(e) => {
        const selectedInvoiceId = e.target.value;
        if (selectedInvoiceId) {
          navigate(`/invoices/${selectedInvoiceId}/edit`);
        }
      }}
      style={{
        padding: '10px',
        bsubscriptionRadius: '4px',
        bsubscription: '1px solid #ccc',
        cursor: 'pointer',
        width: '250px',
      }}
    >
      <option value="">Rechnung wählen</option>
      {subscription.invoices
        .filter(inv => !inv.creditNotes || inv.creditNotes.length === 0)
        .map((invoice) => (
          <option key={invoice.id} value={invoice.id}>
            {`${invoice.invoiceNumber || invoice.id} (${invoice.totalNet} €)`}
          </option>
        ))}
    </select>
  </div>
)}
          
          {/* Auftragsnummer, Auftragsdatum und Auftragsgültigkeit anzeigen*/}
          {subscription.subscriptionNumber && (
            <div>
              <p><strong>Abonummer:</strong> {subscription.subscriptionNumber}</p>
              <p><strong>Abodatum:</strong> {subscription.date ? formatDate(subscription.date) : formatDate(new Date())}</p>

              {/* Neue Abo-spezifische Felder */}
    <div className="abo-daten" style={{ marginTop: "20px" }}>
      <label style={{ display: "block", marginBottom: "10px" }}>
        Abostart:
        <br />
        <input
          type="date"
          name="startDate"
          value={subscription.startDate ? subscription.startDate.split("T")[0] : ""}
          onChange={handleChange}
          style={{
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            width: '250px',
          }}
        />
      </label>
      <label style={{ display: "block", marginBottom: "10px" }}>
        Aboende:
        <br />
        <input
          type="date"
          name="endDate"
          value={subscription.endDate ? subscription.endDate.split("T")[0] : ""}
          onChange={handleChange}
          style={{
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            width: '250px',
          }}
        />
      </label>
      <label style={{ display: "block", marginBottom: "10px" }}>
        Abointervall:
        <br />
        <select
          name="frequencyPoint"
          value={subscription.frequencyPoint || "month"}
          onChange={handleChange}
          style={{
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            width: '250px',
          }}
        >
          <option value="day">Tag</option>
          <option value="month">Monat</option>
          <option value="year">Jahr</option>
        </select>
      </label>
      <label style={{ display: "block", marginBottom: "10px" }}>
        <strong>Abofrequenz:</strong>
        <input
          type="number"
          name="frequencyQuantity"
          value={subscription.frequencyQuantity || 1}
          onChange={handleChange}
          style={{ marginLeft: "10px", padding: "5px", width: "80px" }}
        />
      </label>
      <p style={{ marginTop: "10px" }}>
        <strong>Nächste Abofälligkeit:</strong>{" "}
        {subscription.nextDueDate ? formatDate(subscription.nextDueDate) : "-"}
      </p>
    </div>

  




              {/* Neues Eingabefeld für referenceNumber */}
    <label htmlFor="referenceNumber" className="full-width">
      <strong></strong>
      <input
        type="text"
        id="referenceNumber"
        name="referenceNumber"
        placeholder="Bestellnummer"
        value={subscription.referenceNumber || ""}
        style={{
          padding: '10px',
          bsubscriptionRadius: '4px',
          bsubscription: '1px solid #ccc',
          
          width: '250px',
        }}
        onChange={handleChange}
        className="input-box"
      />
    </label>
              
            </div>
          )}

          {customerContacts.length > 0 ? (
            <>
              <label htmlFor="contactId" className="full-width">
                
                <select
                  id="contactId"
                  name="contactId"
                  value={subscription.contactId}
                  onChange={handleContactChange}
                  className="select-box-bst"
                >
                  <option value="">Besteller wählen</option>
                  {customerContacts.map((contact) => (
                    <option key={contact.id} value={contact.id}>
                      {contact.contactFirstName} {contact.contactLastName}
                    </option>
                  ))}
                </select>
              </label>

              {/* Anzeige der Bestellerinformationen */}
              {selectedContact && (
                <div className="contact-details">
                  <p><strong>Name:</strong> {selectedContact.contactFirstName} {selectedContact.contactLastName}</p>
                  <p><strong>Mobil:</strong> {selectedContact.contactMobile}</p>
                  <p><strong>Email:</strong> {selectedContact.contactEmail}</p>
                  
                </div>
              )}

             
            </>
          ) : (
            <p>Keine Besteller verfügbar</p>
          )}
          

        </div>
      </div>

      <div className="actions">
    {/*    <button type="button" onClick={handleBackButtonClick} style={{ marginRight: '10px', padding: '10px 20px', cursor: 'pointer' }}>
          Zurück
        </button>  */}
        <button type="button" onClick={handleSave} style={{ padding: '10px 20px', cursor: 'pointer' }}>
          {mode === "edit" ? "Speichern" : "Erstellen"}
        </button>
      </div>

     
        





    </div>
  );
};

export default SubscriptionForm;
